<style>
  .btn-warning-ish{
    color: #000000;
    background-color: #faf5e3;
    border-color: #eae3cf;
  }
  .btn-success-ish{
    color: #000;
    background-color: #d9f1e2;
    border-color: #c9e1d2;
  }
  .btn-danger-ish{
    background-color: #ffcccc;
    border-color: #e6adad;
    color: #000;
  }

  .bankBalance-preview-table thead th{
    background: #f4f4f4 !important;
    border-bottom-color: #e9e9e9;
    font-weight: normal;
    text-transform: uppercase;
    font-size: 1em;
    color: #6a6969;
    letter-spacing: 0.03em;
  }

  .bankBalance-preview-table thead th,
  .bankBalance-preview-table tbody td{
    border-right: 1px solid #dddddd;
  }

  .bankBalance-preview-table thead th:first-child,
  .bankBalance-preview-table tbody td:first-child{
    border-left: 1px solid #dddddd;
  }

  .bankBalance-preview-table tbody td{
    border-bottom: 1px solid #dddddd;
  }

  #bankBalanceRejectionForm .modal-body{
    padding-bottom: 0;
  }
</style>

<template>
  <div>
    <div class="card">
      <div class="pl-4 card-header d-flex align-items-center justify-content-between">
        <h5 class="mb-0">Reminders</h5>

        <router-link to="/reminders/add" class="btn btn-primary">
          <!-- v-has-permissions="[PERMISSIONS.TRANSACTION_MAKER]"> -->
          <i class="nav-icon icon-plus"></i>&nbsp;
          Add Reminder
        </router-link>
      </div>

      <div class="card-body" v-if="fetchingReminders || !reminders || !reminders.length">
        <Loader :size="90" v-if="fetchingReminders" />

        <div class="text-center" v-else-if="!reminders">
          Failed to fetch reminders
        </div>

        <div class="text-center" v-else-if="!reminders.length">
          No reminders found
        </div>
      </div>

      <table v-else class="table table-stripped" style="border-top: none !important">
        <thead>
          <tr>
            <th style="padding-left: 1.8em">Title</th>
            <th class="text-center">Type</th>
            <th class="text-center">Message</th>
            <th class="text-center">Repeats</th>
            <th class="text-center">
               <!-- v-has-permissions="[PERMISSIONS.TRANSACTION_CHECKER]"> -->
              Action
            </th>
          </tr>
        </thead>
        <tbody>
          <tr class="text-capitalize" v-for="(reminder, index) in reminders" :key="index">
            <td style="padding-left: 1.8em">
              {{ reminder.title }}
            </td>
            <td class="text-center">{{ reminder.type }}</td>
            <td class="text-center">{{ reminder.message }}</td>
            <td class="text-center" style="text-transform: none">{{ reminder.repeats }}</td>

            <td class="text-center">
              <router-link :to="`/reminders/${reminder._id}/edit`" 
                class="btn btn-sm btn-outline-dark"
                :class="{disabled: reminder.deleting}">
                <i class="fa fa-edit"></i> &nbsp;<span>Edit</span>
              </router-link>&nbsp;
              
              <router-link :to="`/reminders/list/${reminder._id}/delete`" 
                class="btn btn-sm text-danger d-inline-flex align-items-center"
                :class="{disabled: reminder.deleting}">
                <Loader v-if="reminder.deleting" class="d-inline" :size="20" color="red" nopad />
                <i v-else class="fa fa-trash"></i> 
                &nbsp;<span>Delete</span>
              </router-link>
            </td>
          </tr>
        </tbody>
      </table>

      <div class="card-body py-0" v-if="reminders && reminders.totalPages && reminders.totalPages > 1">
        <b-pagination
          :value="reminders.currentPage"
          @change="fetchReminders($event)"
          :total-rows="reminders.totalRows"
        />
      </div>
    </div>

    <router-view></router-view>
  </div>
</template>

<script>
  import { mapState } from 'vuex';
  import { PERMISSIONS } from '@/permissions';

  export default {
    name: 'Reminders',
    data(){
      return {
        PERMISSIONS
      }
    },
    mounted(){
      if(!this.reminders)
        this.fetchReminders();
    },
    computed: {
      ...mapState(['reminders', 'fetchingReminders'])
    },
    methods: {
      fetchReminders(page = 1){
        this.$store.dispatch('getReminders', page);
      }
    }
  }
</script>
